import { useFetch } from "react-admin-base";

export default function DataLoader({ url, children }) {
	const [ data ] = useFetch(url);
	
	if (!data)
	return null;
	
	return <>
		{ data.data.map(a => children(a)) }
	</>;
}
